import React from "react";
import Truck from "assets/images/truck.svg";
import styled from "styled-components";

const Container = styled.div`
    background: #fafbfd;
    padding: 34px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 500px;
`;

const Title = styled.h1`
    font-size: 32px;
    font-weight: 900;
    color: #28586a;
`;

const Description = styled.p`
    font-size: 24px;
    font-weight: 400;
    color: #6b7280;
`;
function NotFound() {
    return (
        <Container>
            <img
                src={Truck}
                alt="not-found"
            />
            <Title>No actual route yet</Title>
            <Description>When an actual route is available, it will be shown here. </Description>
        </Container>
    );
}

export default NotFound;
